import swal from "sweetalert2";

export class Alert {
  static async dangerousConfirmCancel(title, message, yesBtnText = "확인", noBtnText = "취소") {
    const result = await swal.fire({
      title,
      text: message,
      type: "warning",
      html: message,
      showCancelButton: true,
      confirmButtonClass: "btn btn-danger btn-fill",
      cancelButtonClass: "btn btn-cancel btn-fill",
      confirmButtonText: yesBtnText,
      cancelButtonText: noBtnText,
      buttonsStyling: false,
    });

    return !!result.value;
  }
}
